import { useBranchLogo } from '@/entities/Branch';
import { router } from './router';
import { getVfm } from './modals';

export function createUnauthorizedHandler(): () => void {
  return () => {
    try {
      const vfm = getVfm();
      if (vfm) {
        vfm.closeAll();
      }
    } catch (error) {
      console.warn('Failed to close modals:', error);
    }

    router.replace('/login');
  };
}

export function createTokenRefreshedHandler(): () => void {
  return () => {
    const { retryFailedLogos } = useBranchLogo();
    retryFailedLogos();
  };
}
